module.exports = __webpack_public_path__ + "media/add-ons/webinar@3x-21c4bb28.png";